import React, { memo } from 'react'

const SortArrowDownIcon = ({ className }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
    >
      <path
        d="M4.43538 5.355L0.83838 1.2435C0.41388 0.75975 0.75888 2.75779e-07 1.40313 2.75779e-07H8.59713C8.74131 -0.000123345 8.88248 0.0413159 9.00372 0.119356C9.12495 0.197396 9.22113 0.308728 9.28072 0.44002C9.34031 0.571312 9.36079 0.716999 9.33972 0.859633C9.31864 1.00227 9.2569 1.1358 9.16188 1.24425L5.56488 5.35425C5.49448 5.43481 5.40767 5.49937 5.31026 5.54361C5.21286 5.58785 5.10711 5.61074 5.00013 5.61074C4.89315 5.61074 4.78741 5.58785 4.69 5.54361C4.59259 5.49937 4.50578 5.43481 4.43538 5.35425V5.355Z"
        fill="#838992"
      />
    </svg>
  )
}

export default memo(SortArrowDownIcon)
